import React from 'react';
import { ColorSchema, ColorVariant, ComponentState, IconEl, SizeVariant } from '@utils/types.ts';
import SvgClose from '@components/icons/Close.tsx';
import { IconWrapper } from '@components/icons/IconWrapper.tsx';

interface ComponentProps {
  disabled?: boolean;
  color: ColorVariant;
  size: SizeVariant;
  colorSchema: ColorSchema;
  componentState: ComponentState;
  leftIcon?: IconEl;
  dismissible?: boolean;
  onDismiss?: () => void;
  text: string;
}

const mapBackgroundColor = (color: ColorVariant, colorSchema: ColorSchema, state: ComponentState) => {
  return `bg-controls-surface-${colorSchema}-${color}-${state}`;
};

const mapTextColor = (color: ColorVariant, colorSchema: ColorSchema, _: ComponentState) => {
  switch (colorSchema) {
    case 'light':
      switch (color) {
        case 'primary':
          return 'text-controls-surface-dark-primary-default';
        case 'secondary':
          return 'text-controls-surface-dark-secondary-default';
        case 'success':
          return 'text-controls-surface-dark-success-default';
        case 'error':
          return 'text-white';
        case 'warning':
          return 'text-dark-secondary-default';
        case 'info':
          return 'text-white';
        case 'neutral':
          return 'text-dark-secondary-default';
        default:
          return 'text-dark-secondary-default';
      }
    case 'dark':
      switch (color) {
        case 'primary':
          return 'text-white';
        case 'secondary':
          return 'text-white';
        case 'success':
          return 'text-white';
        case 'error':
          return 'text-white';
        case 'warning':
          return 'text-dark-secondary-default';
        case 'info':
          return 'text-white';
        case 'neutral':
          return 'text-dark-secondary-default';
        default:
          return 'text-dark-secondary-default';
      }
    default:
      return 'text-dark-secondary-default';
  }
};

const Tag: React.FC<ComponentProps> = ({ disabled, text, color, dismissible, onDismiss, size, colorSchema, componentState, leftIcon }) => {
  return (
    <>
      <div
        className={[
          'inline-flex flex-row items-center gap-1 whitespace-nowrap',
          size === 'xs' ? 'px-2 rounded-full h-[18px] utility-body-xs' : '',
          size === 'sm' ? 'px-3 rounded-full h-5 utility-body-s' : '',
          size === 'md' ? 'px-3 rounded-full h-6 utility-body-m' : '',
          size === 'lg' ? 'px-3 rounded-full h-8 utility-body-l' : '',
          mapBackgroundColor(color, colorSchema, componentState),
          mapTextColor(color, colorSchema, componentState),
          dismissible === true ? `cursor-pointer hover:${mapBackgroundColor(color, colorSchema, 'hover')}` : '',
        ].join(' ')}
        onClick={() => dismissible === true && onDismiss && !disabled && onDismiss()}
      >
        {leftIcon && <IconWrapper className={'h-4 w-4'}>{leftIcon}</IconWrapper>}
        <div className={''}>{text}</div>
        {dismissible === true && (
          <IconWrapper className={'h-4 w-4'}>
            <SvgClose />
          </IconWrapper>
        )}
      </div>
    </>
  );
};

export default Tag;
